var _excluded = ["media", "title"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { withMedia } from 'react-media-query-hoc';
import { HorizontalSlide } from '../../components/horizontal-slide';
import { CarouselSlide } from '../../components/carousel-slide';
import * as styles from './browse-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseBrowsePage = _ref => {
  var _ref$media = _ref.media,
    media = _ref$media === void 0 ? {
      mobile: true,
      desktop: false
    } : _ref$media,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Property of the Week' : _ref$title,
    carouselProps = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("div", {
    css: styles.browsePage
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, title), media.desktop ? ___EmotionJSX(CarouselSlide, carouselProps) : ___EmotionJSX(HorizontalSlide, carouselProps));
};
var BrowsePage = withMedia(BaseBrowsePage);
export { BrowsePage, BaseBrowsePage };